import React from 'react';


const Contact = () => {
    return ( 
        <div className="Contact">
            <span><i class="fas fa-phone-square-alt"><p>883-824-782</p></i></span>
            <span><i class="fas fa-envelope"><p>norbert.pietruszewski1@gmail.com</p></i></span>
            <a href="https://github.com/norbertaz"><i class="fab fa-github-square"></i></a>
        </div>
     );
}
 
export default Contact;